import {
    BUSINESSNATURESUBCATEGORYTYPE_SUCCESS,
    BUSINESSNATURESUBCATEGORYTYPE_FAILED,
    RESET_BUSINESSNATURESUBCATEGORYTYPE,
    LOADING_BUSINESSNATURESUBCATEGORYTYPE,
    NETWORK_ERROR_BUSINESSNATURESUBCATEGORYTYPE,
} from "../types/index";

import { partnerServices } from "../../config/axios";

const resetbusinessNatureSubCategoryType = () => {
    return { type: RESET_BUSINESSNATURESUBCATEGORYTYPE };
};

const businessNatureSubCategoryTypeUpdate = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_BUSINESSNATURESUBCATEGORYTYPE });
    await partnerServices
        .post("businessNatureSubCategoryType", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(businessNatureSubCategoryTypesuccess(res.data));
                    break;
                default:
                    dispatch(businessNatureSubCategoryTypeFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_BUSINESSNATURESUBCATEGORYTYPE,
                payload: err
            });
        });
};

function businessNatureSubCategoryTypesuccess(data) {
    return {
        type: BUSINESSNATURESUBCATEGORYTYPE_SUCCESS,
        payload: data,
    };
}

function businessNatureSubCategoryTypeFailed(data) {
    return {
        type: BUSINESSNATURESUBCATEGORYTYPE_FAILED,
        payload: data,
    };
}



export { businessNatureSubCategoryTypeUpdate, resetbusinessNatureSubCategoryType };